import { ChangeDetectionStrategy, Component, computed } from '@angular/core';
import { UserLevelBarComponent } from '@core/components/user-level-bar/user-level-bar.component';
import { SessionService } from '@core/services/session.service';
import { SocketService } from '@core/services/socket.service';
import { UserCommonInfoComponent } from '../user-common-info/user-common-info.component';
import { CardComponent } from '../../../core/components/card/card.component';
import { UserTradeUrlComponent } from '../user-trade-url/user-trade-url.component';
import { JoinDiscordWidgetComponent } from '../join-discord-widget/join-discord-widget.component';

@Component({
  selector: 'app-my-profile',
  imports: [
    UserLevelBarComponent,
    UserCommonInfoComponent,
    CardComponent,
    UserTradeUrlComponent,
    JoinDiscordWidgetComponent,
  ],
  templateUrl: './my-profile.component.html',
  styleUrl: './my-profile.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
})
export class MyProfileComponent {
  constructor(
    public sessionService: SessionService,
    private socketService: SocketService
  ) {}

  async toggleProfilePrivacy() {
    await this.socketService.emit('set_profile_privacy', {
      value: this.sessionService.stats().profile_privacy === 0 ? 1 : 0,
    });
    this.sessionService.stats.update((prev) => {
      return {
        ...prev,
        profile_privacy: prev.profile_privacy === 0 ? 1 : 0,
      };
    });
  }
}
